module.exports = __webpack_public_path__ + "static/leaves-1a9f470924986a253c9a129f2aefff04.png";